import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      dashboard: 'Dashboard',
      documents: 'Helpdesk',
      aiChat: 'AI Chat',
      aiStudio: 'AI Studio',
      categories: 'Categories',
      analytics: 'Analytics',
      team: 'Team',
      settings: 'Settings',
      workspaces: 'Workspaces',
      logout: 'Logout',
      switchWorkspace: 'Switch Workspace',
      allWorkspaces: 'All Workspaces',
      
      // Common
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      loading: 'Loading...',
      noResults: 'No results found',
      
      // Auth
      signIn: 'Sign In',
      signUp: 'Sign Up',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      
      // Documents
      newDocument: 'New Article',
      documentTitle: 'Article Title',
      documentContent: 'Content',
      selectCategory: 'Select Category',
      noDocuments: 'No articles yet',
      createFirstDocument: 'Create your first helpdesk article',
      
      // Categories
      createCategory: 'Create Category',
      categoryName: 'Category Name',
      categoryDescription: 'Description',
      parentCategory: 'Parent Category',
      noCategories: 'No categories yet',
      noneTopLevel: 'None (Top Level)',
      level1Category: 'Level 1 (Parent)',
      level2Category: 'Level 2 (Child)',
      level3Category: 'Level 3 (Sub-child)',
      maxNestingReached: 'Maximum nesting level reached (3 levels)',
      
      // Workspace Settings
      workspaceSettings: 'Workspace Settings',
      branding: 'Branding',
      logoUrl: 'Logo URL',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      welcomeMessage: 'Welcome Message',
      contactEmail: 'Contact Email',
      publicAccess: 'Public Access',
      enablePublicAccess: 'Enable Public Access',
      emailNotifications: 'Email Notifications',
      
      // Custom Domain
      customDomain: 'Custom Domain',
      domainVerification: 'Domain Verification',
      verifyDomain: 'Verify Domain',
      domainVerified: 'Domain Verified',
      domainPending: 'Verification Pending',
      domainFailed: 'Verification Failed',
      addCnameRecord: 'Add CNAME record',
      cnameInstructions: 'Point your domain to our servers by adding this CNAME record:',
      
      // Team
      inviteUser: 'Invite User',
      teamMembers: 'Team Members',
      role: 'Role',
      admin: 'Admin',
      editor: 'Editor',
      viewer: 'Viewer',
      
      // Super Admin
      superAdminPanel: 'Super Admin Panel',
      manageWorkspace: 'Manage Workspace',
      impersonate: 'Enter Workspace',
      workspaceDetails: 'Workspace Details',
      totalDocuments: 'Total Documents',
      totalMembers: 'Total Members',
      
      // Public Portal
      searchKnowledgeBase: 'Search knowledge base...',
      askAi: 'Ask AI',
      allDocuments: 'All Documents',
      
      // Public Document
      'common.backTo': 'Back to',
      'common.needHelp': 'Need help? Contact us at',
      'document.tableOfContents': 'Table of Contents',
      'document.views': 'views',
      'document.browseAll': 'Browse all documents',
      'document.translating': 'Translating content...',
      'chat.askAI': 'Ask AI',
      'chat.askAboutDoc': 'Ask questions about this document',
      'chat.startConversation': 'Ask a question about this document',
      'chat.placeholder': 'Type your question...',
      'chat.error': 'Sorry, I encountered an error. Please try again.',
      saveSettings: 'Save Settings',
      settingsSaved: 'Settings saved!',
      
      // SMTP Settings
      smtpSettings: 'SMTP Settings',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUsername: 'Username',
      smtpPassword: 'Password',
      smtpFrom: 'From Email',
      testConnection: 'Test Connection'
    }
  },
  fr: {
    translation: {
      // Navigation
      dashboard: 'Tableau de bord',
      documents: 'Centre d\'aide',
      aiChat: 'Chat IA',
      aiStudio: 'Studio IA',
      categories: 'Catégories',
      analytics: 'Analytique',
      team: 'Équipe',
      settings: 'Paramètres',
      workspaces: 'Espaces de travail',
      logout: 'Déconnexion',
      switchWorkspace: "Changer d'espace",
      allWorkspaces: 'Tous les espaces',
      
      // Common
      save: 'Enregistrer',
      cancel: 'Annuler',
      create: 'Créer',
      edit: 'Modifier',
      delete: 'Supprimer',
      search: 'Rechercher',
      loading: 'Chargement...',
      noResults: 'Aucun résultat trouvé',
      
      // Auth
      signIn: 'Connexion',
      signUp: 'Inscription',
      email: 'E-mail',
      password: 'Mot de passe',
      name: 'Nom',
      
      // Documents
      newDocument: 'Nouveau document',
      documentTitle: 'Titre du document',
      documentContent: 'Contenu',
      selectCategory: 'Sélectionner une catégorie',
      noDocuments: 'Aucun document',
      createFirstDocument: 'Créez votre premier document',
      
      // Categories
      createCategory: 'Créer une catégorie',
      categoryName: 'Nom de la catégorie',
      categoryDescription: 'Description',
      parentCategory: 'Catégorie parente',
      noCategories: 'Aucune catégorie',
      noneTopLevel: 'Aucune (Niveau principal)',
      level1Category: 'Niveau 1 (Parent)',
      level2Category: 'Niveau 2 (Enfant)',
      level3Category: 'Niveau 3 (Sous-enfant)',
      maxNestingReached: 'Niveau d\'imbrication maximum atteint (3 niveaux)',
      
      // Workspace Settings
      workspaceSettings: 'Paramètres de l\'espace',
      branding: 'Image de marque',
      logoUrl: 'URL du logo',
      primaryColor: 'Couleur principale',
      secondaryColor: 'Couleur secondaire',
      welcomeMessage: 'Message de bienvenue',
      contactEmail: 'E-mail de contact',
      publicAccess: 'Accès public',
      enablePublicAccess: 'Activer l\'accès public',
      emailNotifications: 'Notifications par e-mail',
      
      // Custom Domain
      customDomain: 'Domaine personnalisé',
      domainVerification: 'Vérification du domaine',
      verifyDomain: 'Vérifier le domaine',
      domainVerified: 'Domaine vérifié',
      domainPending: 'Vérification en attente',
      domainFailed: 'Échec de la vérification',
      addCnameRecord: 'Ajouter un enregistrement CNAME',
      cnameInstructions: 'Pointez votre domaine vers nos serveurs en ajoutant cet enregistrement CNAME:',
      
      // Team
      inviteUser: 'Inviter un utilisateur',
      teamMembers: 'Membres de l\'équipe',
      role: 'Rôle',
      admin: 'Administrateur',
      editor: 'Éditeur',
      viewer: 'Lecteur',
      
      // Super Admin
      superAdminPanel: 'Panneau Super Admin',
      manageWorkspace: 'Gérer l\'espace',
      impersonate: 'Entrer dans l\'espace',
      workspaceDetails: 'Détails de l\'espace',
      totalDocuments: 'Total des documents',
      totalMembers: 'Total des membres',
      
      // Public Portal
      searchKnowledgeBase: 'Rechercher dans la base de connaissances...',
      askAi: 'Demander à l\'IA',
      allDocuments: 'Tous les documents',
      
      // Public Document
      'common.backTo': 'Retour à',
      'common.needHelp': 'Besoin d\'aide? Contactez-nous à',
      'document.tableOfContents': 'Table des matières',
      'document.views': 'vues',
      'document.browseAll': 'Parcourir tous les documents',
      'document.translating': 'Traduction du contenu en cours...',
      'chat.askAI': 'Demander à l\'IA',
      'chat.askAboutDoc': 'Posez des questions sur ce document',
      'chat.startConversation': 'Posez une question sur ce document',
      'chat.placeholder': 'Tapez votre question...',
      'chat.error': 'Désolé, une erreur est survenue. Veuillez réessayer.',
      saveSettings: 'Enregistrer les paramètres',
      settingsSaved: 'Paramètres enregistrés!',
      
      // SMTP Settings
      smtpSettings: 'Paramètres SMTP',
      smtpHost: 'Hôte SMTP',
      smtpPort: 'Port SMTP',
      smtpUsername: 'Nom d\'utilisateur',
      smtpPassword: 'Mot de passe',
      smtpFrom: 'E-mail expéditeur',
      testConnection: 'Tester la connexion'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
